var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLrgy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.115925,
    y: 0.115925,
    width: 14.8384,
    height: 14.8384,
    rx: 1.04333,
    transform: "matrix(-1 0 0 1 15.2276 0.873047)",
    fill: "#D9D9D9",
    stroke: "#666666",
    strokeWidth: 0.23185
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66281 12.4656L6.18506 8.4082L9.66281 4.35082",
    stroke: "#7A7A7A",
    strokeWidth: 1.15925,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLrgy);
export default __webpack_public_path__ + "static/media/lrgy.68f5cd9d7b54be0885ad6a84c109bea0.svg";
export { ForwardRef as ReactComponent };